module.exports = __webpack_public_path__ + "static/media/crveni-vjetar.792e3c5c.png";